import React from "react";
import { Stack, Box, Typography } from "@mui/material";

export const HomeContent = ({ translate }) => {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      justifyContent={{ xs: "start", md: "center" }}
      alignItems="center"
      spacing={2}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mr: "20px",
        }}
        flex={0.5}
      >
        <img
          src="/images/SBP_CONLogo_trans.png"
          alt="logo company"
          width={170}
          height={170}
          loading="lazy"
        />
      </Box>
      <Box flex={1}>
        <Box>
          <Typography variant="h5" gutterBottom>
            <b>{translate("TITLE")}</b>
          </Typography>
        </Box>
        <Box sx={{ marginBottom: "15px" }}>
          <Typography variant="subtitle2" sx={{ textIndent: "50px" }}>
            {translate("aboutUsFooter")}
          </Typography>
        </Box>
      </Box>
    </Stack>
  );
};
